import { useState, useEffect } from 'react';

export const useCheckboxGroup = ({options, optionsChecked, onChange: setOptionsChecked}) => {
  const optionsCheckedIds = optionsChecked || [];
  const [ optionsIds, setOptionsIds ] = useState(optionsCheckedIds);

  const makeToChecked = (optionIds) => {
    return options.map(option => ({
      ...option,
      isChecked: optionIds.includes(option.id)
    }));
  };

  const onChangeOptionsIds = (optionsIds) => {
    const optionsChecked = makeToChecked(optionsIds);

    setOptionsIds(optionsIds);
    setOptionsChecked(optionsChecked);
  };

  const onChangeSelectValue = (value, { id }) => {
    const optionsChecked = makeToChecked(optionsIds);
    const options = optionsChecked.map((option) => {
      return {
        ...option,
        ...(option.id === id ? {selectValue: value} : {})
      }
    });

    setOptionsChecked(options);
  };

  useEffect(() => {
    if (optionsCheckedIds && optionsCheckedIds.length) {
      const optionsChecked = makeToChecked(optionsCheckedIds);

      setOptionsChecked(optionsChecked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [
    optionsIds,
    onChangeOptionsIds,
    onChangeSelectValue
  ]
};
